module.exports = __webpack_public_path__ + "img/chaBing3.198a7981.png";